import './polyfill';
import '@fontsource/plus-jakarta-sans/400.css';
import '@fontsource/plus-jakarta-sans/500.css';
import '@fontsource/plus-jakarta-sans/600.css';
import '@fontsource/plus-jakarta-sans/700.css';
import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import './config/config.styles.scss';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { ggSentry } from './config/sentry';
import { ggAnalytics } from './config/ga';
import { createBrowserHistory } from 'history';
import { ChakraProvider } from '@chakra-ui/react';
import { chakraTheme } from './config/chakra';
import { BrowserRouter } from 'react-router-dom';
import ReloadApp from 'components/ReloadApp';

ggSentry.initialize(process.env.REACT_APP_SENTRY);
ggAnalytics.initialize(process.env.REACT_APP_GA);

const history = createBrowserHistory();

function Root() {
  return (
    <>
      <ReloadApp />

      <React.StrictMode>
        <ChakraProvider theme={chakraTheme}>
          <BrowserRouter>
            <App history={history} />
          </BrowserRouter>
        </ChakraProvider>
      </React.StrictMode>
    </>
  );
}
ReactDOM.render(<Root />, document.getElementById('root'));

reportWebVitals();
